import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewListImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Stock';

const routes = [
	{
		matchRegex: '/Stock/Create',
		name: getRouteName(MODULE_NAME, 'Create Stock Record'),
		image: PreviewDetailImg,
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_SECTION],
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-bottom-bar', label: 'Page Bottom Bar' },
			],
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'detail-form-wrapper', label: 'Detail Form Wrapper' },
				{ key: 'quantity-unit', label: 'Quantity Unit' },
			]
		},
		replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'stock-quantity-element', label: 'Stock Quantity Element' },
            ],
        },
	},
	{
		matchRegex: '/Stock',
		name: getRouteName(MODULE_NAME, 'All Stock Record'),
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'stock-table', label: 'Stock Table' }]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [{ key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS', label: 'Trigger Fetch List Successfully' }]
		}
	},
	{
		matchRegex: '/Stock/Detail/:id',
		name: getRouteName(MODULE_NAME, 'Stock Record Detail'),
		slots: [
			SLOT_KEY.SLOT_TAB, 
			SLOT_KEY.SLOT_CONTENT, 
			SLOT_KEY.SLOT_V_SECTION, 
			SLOT_KEY.SLOT_SCRIPTS, 
			SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SECTION,
		],
		image: PreviewDetailImg,
		description: {
			[SLOT_KEY.SLOT_TAB]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`,
			[SLOT_KEY.SLOT_CONTENT]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`
		},
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' },
				{ key: 'tab-details-form-wrapper', label: 'Tab Details - Detail Form Wrapper' },
				{ key: 'wrapper-section-audit', label: 'Tab History - Stock Request Location Audit - Wrapper' },
				{ key: 'quantity-audit-section-wrapper', label: 'Tab History - Quantity Audit - Wrapper' },
                { key: 'stock-unit-of-measure', label: 'Stock Unit Of Measure' },
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
				{ key: 'stock-location', label: 'Tab Stock Location - Stock Location Table' },
				{ key: 'audit-table-StockRecord', label: 'Tab History - Stock Request Location Audit - Audit Table' },
				{ key: 'stock-quantity-audit-table', label: 'Tab History - Quantity Audit - Audit Table' }
			],
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_STOCK_TRANSFER', label: 'After Click Button Transfer Stock' },
				{ key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS', label: 'Trigger Fetch List Successfully' },
                {
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_AUDIT_SUCCESS',
                    label: 'Trigger Fetch List Audit Successfully',
                },
                {
                    key: 'MARKETPLACE_EVENT_DELETE_STOCK_RECORD_SUCCESS',
                    label: 'Delete Stock Record Successfully',
                },
			]
		},
		replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'unit-of-measure-element', label: 'Stock Unit Of Measure Element' },
            ],
        },
	},
	{
		matchRegex: '/Location',
		name: getRouteName(MODULE_NAME, 'All Stock Location'),
		image: PreviewListImg,
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN],
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'location-table', label: 'Location Table' }]
		}
	},
	{
		matchRegex: '/StockTake',
		name: getRouteName(MODULE_NAME, 'All Stock Take'),
		image: PreviewListImg,
		slots: [SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN],
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'stock-take-table', label: 'Stock Take Table' }]
		},
		description: {
			[SLOT_KEY.SLOT_TAB]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`,
			[SLOT_KEY.SLOT_CONTENT]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`
		}
	},
	{
		matchRegex: '/StockTake/Detail/:id',
		name: getRouteName(MODULE_NAME, 'Stock Take Detail'),
		slots: [SLOT_KEY.SLOT_TAB, SLOT_KEY.SLOT_CONTENT, SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewDetailImg,
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' },
				{ key: 'tab-details-form-wrapper', label: 'Tab Details - Detail Form Wrapper' }
			],
			[SLOT_KEY.SLOT_V_SECTION]: [{ key: 'wrapper-section-audit', label: 'Tab History - Audit - Wrapper' }],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
				{ key: 'tab-details-detail-table', label: 'Tab Details - Detail Table' },
				{ key: 'audit-table-StockTake', label: 'Tab History - Audit - Audit Table' }
			]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{ key: 'MARKETPLACE_EVENT_CHECK_AVAILABLE_QUANTITY', label: 'Check Available Quantity' },
				{ key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS', label: 'Trigger Fetch List Successfully' },
				{ key: 'MARKETPLACE_EVENT_DOWNLOAD_TEMPLATE', label: 'Trigger Download Import Template' }
			]
		},
		description: {
			[SLOT_KEY.SLOT_TAB]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`,
			[SLOT_KEY.SLOT_CONTENT]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`
		}
	},
	{
		matchRegex: '/StockReorder',
		name: getRouteName(MODULE_NAME, 'All Stock Reorder Report'),
		slots: [
			SLOT_KEY.SLOT_V_SECTION, 
			SLOT_KEY.SLOT_V_TABLE_COLUMN, 
			SLOT_KEY.SLOT_SCRIPTS,
		],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'stock-reorder-report-table', label: 'Stock Reorder Report Table' }],
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [
				{
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
			]
		},
	},
	{
		matchRegex: '/Stock/StockValuationReport',
		name: getRouteName(MODULE_NAME, 'Stock Valuation Report'),
		image: PreviewListImg,
		slots: [SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN],
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'stock-valuation-report-table', label: 'Stock Valuation Report Table' }]
		}
	},
	{
		matchRegex: '/StockAdjustment',
		name: getRouteName(MODULE_NAME, 'Stock Adjustment Report'),
		slots: [SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [{ key: 'stock-adjustment-report-table', label: 'Stock Valuation Report Table' }]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [{ key: 'MARKETPLACE_EVENT_CHECK_AVAILABLE_QUANTITY', label: 'Check Available Quantity' }]
		}
	},
	{
		matchRegex: '/StockAdjustment/Detail',
		name: getRouteName(MODULE_NAME, 'Stock Adjustment Detail'),
		image: PreviewDetailImg,
		slots: [SLOT_KEY.SLOT_TAB, SLOT_KEY.SLOT_CONTENT, SLOT_KEY.SLOT_SECTION, SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_TABLE_COLUMN],
		parentKeys: {
			[SLOT_KEY.SLOT_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }
			],
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'tab-details-form-wrapper', label: 'Tab Details - Detail Form Wrapper' },
				{ key: 'wrapper-section-audit', label: 'Tab History - Audit - Wrapper' }
			],
			[SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
				{ key: 'stock-adjustment-item-table', label: 'Stock Adjustment Item Table' },
				{ key: 'audit-table-StockAdjustment', label: 'Tab History - Audit - Audit Table' }
			]
		},
		description: {
			[SLOT_KEY.SLOT_TAB]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`,
			[SLOT_KEY.SLOT_CONTENT]: `Embedded source: "id" must be start with prefix "MarketplaceTab_"`
		}
	},
	{
		matchRegex: '/Stock/StockBulkTransfer',
		name: getRouteName(MODULE_NAME, 'Stock Bulk Transfer'),
		slots: [SLOT_KEY.SLOT_V_SECTION, SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
		image: PreviewListImg,
		parentKeys: {
			[SLOT_KEY.SLOT_V_SECTION]: [
				{ key: 'page-title', label: 'Page Title' },
				{ key: 'page-bottom-bar', label: 'Page Bottom Bar' }
			],
			[SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
				{ key: 'stock-record-header', label: 'Stock Record Table - Header' },
				{ key: 'stock-record-body', label: 'Stock Record Table - Body' }
			]
		},
		options: {
			[SLOT_KEY.SLOT_SCRIPTS]: [{ key: 'MARKETPLACE_EVENT_CHECK_AVAILABLE_QUANTITY', label: 'Check Available Quantity' }]
		}
	}
];

export default routes;
